<template>

  <!-- ------------------------------------------- -->
  <!-- --------------- CONTENT ------------------- -->
  <!-- ------------------------------------------- -->

  <div class="contentDiv">

    <!-- ------------------------- CARD NEW ----------------------- -->

    <div class="cardNew">
      <div class="container">

        <div class="instructionsLeft" style="margin-top: 15px">
          <div class="header-secondary">Instructions</div>
        </div>


        <div class="instructionsLeft" style="margin-left: 15px; margin-right: 15px; margin-top: 10px;"><b>Please Note:</b> When an individual is moved from one
          contract to another, the following actions will be performed:
        </div>

        <div class="instructionsLeft instructionsActions" style="margin-bottom: 10px; margin-left: 30px;"
          @click="handleToggleInstructions">
          <span v-if="!showInstrutions" class="expandContractPlus">+</span>
          <span v-if="showInstrutions" class="expandContractMinus">-</span>
          <span v-if="!showInstrutions"><b>(Show instuctions)</b></span>
          <span v-if="showInstrutions"><b>(Hide instuctions)</b></span>
        </div>

        <div v-if="showInstrutions">
          <ul style="margin-left: 25px;">
            <li class="liStyle">The existing SPOT/DTS(LOA) will be changed to "LOA Needed".</li>
            <li class="liStyle">The existing Deployment Start and End dates will be removed.</li>
            <li class="liStyle">The existing AAL Number and Expiration date will be removed.</li>
            <li class="liStyle">The existing Weapons Qualification information will be removed.</li>
            <li class="liStyle">The existing Security Type will be removed.</li>
            <li class="liStyle">The existing Employer will be removed.</li>
            <li class="liStyle">The most recent version of each document type uploaded will be available.</li>
            <li class="liStyle">The existing status will be set to "New".</li>
          </ul>

          <div style="text-align: left; padding-bottom: 30px; margin-left: 15px; margin-right: 15px;">
            <div style="margin: 0px;"><b>Transfers:</b> To transfer this individual to another contract,
              select the new contract from the dropdown list below.</div>
            <div style="margin: 0px;">Click on the <b>Transfer Record button</b> button make the transfer. <span
                style="color: darkred"><b>Note this
                  action is irreversible.</b></span>
            </div>
          </div>
        </div>

      </div>
    </div>

  </div>
  
  <!-- ------------------------------------------- -->
  <!-- --------------- CONTENT ------------------- -->
  <!-- ------------------------------------------- -->

  <div class="contentDiv cardUpperMargin" v-if="showDbConfirmation">

    <!-- ------------------------- CARD NEW ----------------------- -->

    <div class="cardNew">
      <div class="container">

        <div class="instructionsLeft" style="margin-top: 15px">
          <div class="header-secondary">Transfer Confirmation</div>
        </div>


        <div class="instructionsLeft" style="margin-left: 15px; margin-right: 15px; margin-top: 8px; margin-bottom: 0px; padding: 0px;">
          <span style="font-weight: bold; color: darkred;">The transfer was accomplished Successfully:</span>
          <div style="margin-top: 8px; margin-bottom: 0px; padding: 0px;">
            <ul style="padding-top: 0px; padding-bottom: 0px; margin-top: 0px; margin-bottom: 0px;">
              <li style="padding-top: 0px; padding-bottom: 0px; margin-top: 0px; margin-bottom: 0px;">
                From: <b>{{ previousContractNumberForVerification }}</b> To: <b>{{ contractNumber }}</b>
              </li>
            </ul>
          </div>
        </div>

        <div class="instructionsLeft instructionsActions" style="margin-bottom: 10px; margin-top: 5px; margin-left: 20px;"
          @click="handleToggleDbActions">
          <span v-if="!showDbActions" class="expandContractPlus">+</span>
          <span v-if="showDbActions" class="expandContractMinus">-</span>
          <span v-if="!showDbActions"><b>(Show Detailed Database Changes)</b></span>
          <span v-if="showDbActions"><b>(Hide Detailed Database Changes)</b></span>
        </div>

        <div v-if="showDbActions">
          <ul style="margin-left: 25px;">
            <li class="liStyle">Contract ID updated</li>
            <li class="liStyle">SPOT/DTS (LOA) Set to "LOA Needed"</li>
            <li class="liStyle">Deploy-Start-Date deleted</li>
            <li class="liStyle">Deploy-End-Date deleted</li>
            <li class="liStyle">AAL-Number deleted</li>
            <li class="liStyle">AAl-Expire-Date deleted</li>
            <li class="liStyle">Security-Type deleted</li>
            <li class="liStyle">Company deleted</li>
            <li class="liStyle">Arming-Status set to "new"</li>
            <li class="liStyle">Last-Update-Email set to Updating User's Email</li>
            <li class="liStyle">Last-Update-By set to User's User-Profile-ID</li>
            <li class="liStyle">Last-Update-Date set to the Current Date</li>
            <li class="liStyle">Confirm-Date set to Default Date (1/1/2000)</li>
            <li class="liStyle">Person's Weapon Data deleted</li>
            <li class="liStyle">inTheater-Arrival-Date deleted</li>
            <li class="liStyle">IsRenewal set to zero</li>
          </ul>
        </div>

        <hr style="margin-top: 0px; margin-bottom: 0px;" />

        <div style="margin-bottom: 10px; margin-top: 10px;">
          <button @click="handleHideConfirmationClick" class="allButtons" 
            type="button"> 
            Hide</button>
        </div>

      </div>
    </div>

  </div>

  <!-- ------------------------------------------- -->
  <!-- --------------- CONTENT ------------------- -->
  <!-- ------------------------------------------- -->

  <div class="contentDiv cardUpperMargin">

    <!-- ------------------------- CARD NEW ----------------------- -->

    <div class="cardNew">
      <div class="container">

        <div class="instructionsLeft" style="margin-top: 15px">
          <div class="header-secondary">Person Contract Transfer</div>
        </div>

        <div class="instructionsLeft" style="margin-top: 10px;">

          <div style="margin-left: 15px; margin-right: 15px; margin-top: 10px; margin-bottom: 5px; text-align: center;">
            <b>Name: </b> 
             
            <span style="color: darkred; font-weight: bold;">{{ lastName }}, {{ firstName }}</span>
            <div style="display: inline-block; margin-left: 15px;">
              <b>Current Contract: </b> 
              <span style="color: darkred; font-weight: bold;">{{ contractNumber }}</span>
            </div>
          </div>

        </div>

        <div style="margin-top: 10px;"><b>Transfer To:</b>

          <select id="ddlContractID" @change="setSubmitDisableValue" v-model="selectedContractID" class="ctrlBorderRadius ctrlDropDown ctrlDropDownMargin" aria-label="Select a contract from the drop down list">
            <option v-for="item in contractList" :value="item.contractId" :key="item.contractId">
              {{ item.contractNumber }}
            </option>
          </select>

        </div>

        <!-- class="btn btn-primary xmodal-yesSubmitButton"  -->

        <hr style="margin-top: 10px; margin-bottom: 10px;" />

        <div style="margin-bottom: 10px; margin-top: 0px;">

          <button @click="handleBackClick" class="allButtons btn-primary" type="button">
            Back to Previous Page
          </button>

          <button v-if="disableSubmit" id="submitBtnID" 
                  class="allButtonsDisabled" 
                  style="margin-left: 15px;"
                  disabled
                  type="button">Transfer Record
          </button>
            
          <button v-if="!disableSubmit" id="submitBtnID" 
                  @click="handleTransferClick" 
                  class="allButtons btn-primary" 
                  style="margin-left: 15px;"
                  type="button">Transfer Record
          </button>


        </div>

      </div>
    </div>

  </div>

  <!-- ----------------------------------------------------------------------------- -->
  <!-- --------------------------- MODAL Update-Create start ------------------------ -->
  <!-- ------------------------------------------------------------------------------ -->

  <div id="xmodal-main-ID" class="xmodal-container-main">
    <div class="xmodal-container-content">

      <!-- ---------------------------------------------------------------- -->
      <!-- --------------------------- HEADER ----------------------------- -->
      <!-- ---------------------------------------------------------------- -->

      <div class="header-primary">{{ modalTitle }}</div>

      <hr class="xmodal-hr-top" />

      <!-- ---------------------------------------------------------------- -->
      <!-- --------------------------- FORM ------------------------------- -->
      <!-- ---------------------------------------------------------------- -->

      <div class="xmodal-container-form">
        <div>Are you sure you want to transfer to a new contract
          (This action is <span style="color: darkred; margin-left: 5px;"><b>irreversible</b></span>)?
        </div>
      </div>

      <hr class="xmodal-hr-bottom" />

      <!-- ---------------------------------------------------------------- -->
      <!-- --------------------------- Footer ----------------------------- -->
      <!-- ---------------------------------------------------------------- -->

      <div class="xmodal-footer">
        <button type="button" @click="handleCancelTransfer"
          class="allButtons btn-danger">
          No - Cancel Transfer
        </button>
        <button id="xmodal-submit-btn-id" type="button" 
          @click="handleSubmitTransfer"
          class="allButtons  btn-primary"
          style="margin-left: 15px;">
          Yes - Submit Transfer
        </button>
      </div>
    </div>
  </div>

</template>
  
<script>
import axios from "axios";
import { store } from "../../store/store.js";

    export default {
        data() {
            return {
                personID: null,
                firstName: null,
                lastName: null,
                modalTitle: null,
                defaultContract: { contractId: -1, contractNumber: 'Please Select a Value' },
                selectedContractID: -1,
                contractList: null,
                disableSubmit: false,

                previousContractNumberForVerification: null,

                showInstrutions: false,
                showDbActions: false,
                showDbConfirmation: false,

                contractID: null,
                contractNumber: null,
            };
        },

        props: {},
        emits: [],
        watch: {},
        mounted() {
            this.setSubmitDisableValue();
        },

        created() {
            // console.log('**** created ****');

    this.setPersonContractDetails();
    this.GetContractForUserRoleWithArchive();
  },
  components: {},
  computed: {
    UserProfileId() {
      return store.authenticatedUser.userProfileId != null
        ? store.authenticatedUser.userProfileId
        : store.tempUserProfileId;
      },
      UserEmail() {
          return store.authenticatedUser.email != null
              ? store.authenticatedUser.email
              : store.tempUserEmail;
      }
  },

  methods: {

    setSubmitDisableValue () {

      // console.log('--- setSubmitDisableValue ---');
      // console.log('Before: this.$data.selectedContractID = ', this.$data.selectedContractID);

      let submitBtn = document.querySelector("#submitBtnID");

      if (this.$data.selectedContractID == -1) {
        submitBtn.disabled = true;
        this.$data.disableSubmit = true;
      } else if (this.$data.selectedContractID > -1) {
        submitBtn.disabled = false;
        this.$data.disableSubmit = false;
      }
    },

    //This is called in response to clicking the pencil icon for a record. The dialog
    //modal is opened due to properties set in the edit div. 
    handleTransferClick() {

      this.$data.modalTitle = 'Transfer Confirmation';

      let modalWindow = document.querySelector("#xmodal-main-ID");
      modalWindow.style.display = "block";

    },

    handleCancelTransfer() {
      let modalWindow = document.querySelector("#xmodal-main-ID");
      modalWindow.style.display = "none";
    },

    handleSubmitTransfer() {
      let modalWindow = document.querySelector("#xmodal-main-ID");
      modalWindow.style.display = "none";

      // console.log('this.UserProfileId = ', this.UserProfileId);
      // console.log('this.$data.selectedContractID = ', this.$data.selectedContractID);

      this.transferContract();

    },

    handleToggleInstructions() {
      this.$data.showInstrutions = !this.$data.showInstrutions;
    },

    handleToggleDbActions() {
      this.$data.showDbActions = !this.$data.showDbActions;
    },

    handleHideConfirmationClick() {
      this.$data.showDbConfirmation = !this.$data.showDbConfirmation;
    },

    handleBackClick() {
      this.$router.push({ name: 'PersonsByContractMaster', params: { contractId: this.$data.contractID } });
    },

    setPersonContractDetails() {
      // console.log('--- PersonTransfer.vue ---');
      this.$data.personID = this.$route.params.personID;
      this.$data.firstName = this.$route.params.firstName;
      this.$data.lastName = this.$route.params.lastName;

      this.$data.contractID = this.$route.params.contractId;
      this.$data.contractNumber = this.$route.params.contractNumber;

      // this.logPersonContractDetails();
    },

    logPersonContractDetails() {
      console.log('this.$data.personID = ', this.$data.personID);
      console.log('this.$data.firstName = ', this.$data.firstName);
      console.log('this.$data.lastName = ', this.$data.lastName);
      console.log('this.$data.contractID = ', this.$data.contractID);
      console.log('this.$data.contractNumber = ', this.$data.contractNumber);
    },

    // --------------------------------------------------------------------------
    // ---------------- getAllContracts -----------------------------------------
    // --------------------------------------------------------------------------

    GetContractForUserRoleWithArchive() {
      // console.log("PersonTransfer.vue GetContractForUserRoleWithArchive()");
     //  console.log('this.UserProfileId = ', this.UserProfileId);
     //console.log('this.UserEmail = ', this.UserEmail);
      axios
        .get(store.webAPIUrl + "Contract/getContractForUserRoleWithArchive/" + this.UserProfileId)
        .then((response) => response.data)
        .then((data) => {
          this.$data.contractList = data;
          // console.log('data = ', data);

          //Add the default item to the top of the list.
          this.$data.contractList.unshift(this.$data.defaultContract);
          //Make the selection for the dropdown list.
          this.$data.selectedContractID = this.$data.defaultContract.contractId;

          // console.log('this.$data.selectedContractID = ', this.$data.selectedContractID);
          // console.log('this.$data.contractList = ', this.$data.contractList);

        });
    },

    // --------------------------------------------------------------------------
    // ---------------- transferContract ----------------------------------------
    // --------------------------------------------------------------------------

    transferContract() {
      // console.log('--- transferContract() ---');

      // console.log('this.UserProfileId = ', this.UserProfileId);
      // console.log('this.$data.personID = ', this.$data.personID);
      // console.log('this.$data.selectedContractID = ', this.$data.selectedContractID);

      let formData = new FormData();
      formData.append("UserProfileID",this.UserProfileId);
      formData.append("PersonID",this.$data.personID);
      formData.append("ContractId",this.$data.selectedContractID);
      formData.append("UserEmail",this.UserEmail);

      axios
        .post(store.webAPIUrl + "Contract/TransferPersonContract/",formData)
        .then((response) => response.data)
        .then((data) => {
          // console.log('data: ', data);
          // console.log('data.contractId = ', data.contractId);
          // console.log('data.contractNumber = ', data.contractNumber);

          this.$data.previousContractNumberForVerification = this.$data.contractNumber;

          this.$data.contractNumber = data.contractNumber;
          this.$data.contractID = data.contractNumber;

          this.$data.selectedContractID = this.$data.defaultContract.contractId;
          this.$data.showDbConfirmation = true;

          this.setSubmitDisableValue ();

        });
    },

  },
};
</script>
  
<style scoped>

/* ---------------------- Controls -------------------- */

option:first-of-type {
  color: blue;
}

.ctrlBorderRadius {
  border: 1px solid #d9d9d9;
  border-radius: 6px;
}

.ctrlDropDown {
  height: 30px;
  padding: 5px;
}

.ctrlDropDownMargin {
  margin-left: 10px;
}

/* ------------------- buttons ------------------------ */

.allButtons {
  font-size: 14px; 
  padding-top: 5px; 
  padding-bottom: 5px; 
  padding-left: 15px; 
  padding-right: 15px; 
}

/* ------------------- buttons ------------------------ */

.expandContractPlus {
  margin-right: 5px;
  font-weight: bold;
  font-size: 18px;
  color: darkred;
}

.expandContractMinus {
  margin-right: 5px;
  font-weight: bold;
  font-size: 24px;
  color: darkred;
}

.instructionsActions {
  cursor: pointer;
}

.instructionsLeft {
  text-align: left;
  margin: auto;
}

.contentDiv {

  display: grid;
  justify-content: center;
  align-items: center;

  /* background-color: lightcoral; */

  width: 100%;
  padding: 0px;
  /* border: 1px solid blue; */
}

.cardUpperMargin {
  margin-top: 30px;
}

.liStyle {
  margin-left: 10px;
  text-align: left;
}

/* ----------------- SHADOW BOX ------------------------- */

.cardNew {
  width: 100%;
  border: 1px solid black;
}

/* .cardNew {
  box-shadow: rgba(50, 50, 93, 0.25) 0px 50px 30px -20px, rgba(0, 0, 0, 0.3) 0px 30px 15px -30px, rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset;
  width: 100%;
  border: 1px solid lightgrey;
} */


/* .cardNew {
  box-shadow: rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px, rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset;
  width: 100%;
  border: 1px solid white;
} */

/* -------------------------------------------------------------- */
/* ------------------- start modal style ------------------------ */
/* -------------------------------------------------------------- */

option:first-of-type {
  color: blue;
}

/* ---------- containers ---------- */

.xmodal-container-main {
  display: none;
  /* Hidden by default */
  position: fixed;
  /* Stay in place */
  z-index: 1;
  /* Sit on top */
  padding-top: 50px;
  /* Location of the box */
  left: 0;
  top: 0;
  width: 100%;
  /* Full width */
  height: 100%;
  /* Full height */
  overflow: auto;
  /* Enable scroll if needed */
  background-color: rgb(0, 0, 0);
  /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4);
  /* Black w/ opacity */
}

.xmodal-container-form {
  margin: 5px;
  display: grid;
  grid-template-columns: 100%;
  align-items: center;
  justify-content: center;

  /* background-color: lightyellow; */
}

.xmodal-container-content {
  background-color: #fefefe;
  margin: auto;

  padding: 20px;
  border: 1px inset black;

  width: 700px;
  height: 225px;
  margin-bottom: 250px;
  overflow-x: auto;
}

/* ---------- header and footer ---------- */

.xmodal-footer {
  text-align: center;
}

/* ---------- buttons ---------- */
.allButtonsDisabled {
  border-radius: 6px;
  font-size: 15px;
  padding-top: 3px;
  padding-bottom: 3px;
  padding-left: 10px;
  padding-right: 10px;
  cursor: default;
  color: white;
  background-color: #3e79a8;
}


.allButtons {
  border-radius: 6px;
  font-size: 15px;
  padding-top: 3px;
  padding-bottom: 3px;
  padding-left: 10px;
  padding-right: 10px;
  cursor: pointer;
  color: white;
  background-color: #1063A8;
}

.allButtons:Hover {
  background-color: #0f5691;
}

/* ---------- hr separators ---------- */

.xmodal-hr-top {
  margin-bottom: 20px;
  background-color: #E6E6E6;
}

.xmodal-hr-bottom {
  margin-top: 20px;
  margin-bottom: 20px;
  background-color: #E6E6E6;
}

/* --------------------------------------------- */
/* -------------- end Modal style -------------- */
/* --------------------------------------------- */
</style>
  